import React from "react";
import { motion } from "framer-motion";

type FadeInProps = {
  children: React.ReactNode;
  className?: string;
};

export const FadeInDiv: React.FC<FadeInProps> = ({ children, className }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
